// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9be8e51d","453":"c00f7f9e","732":"d78d5b95","977":"baae7250"}[chunkId] + ".chunk.js";
};